<template>
    <v-switch v-model="flg" :disabled="isDisabled" :loading="isLoading" class="text-caption pa-0 ma-0" color="accent">
        <template v-slot:label>
            <span key="enable-mode" class="text-caption">
                {{ flg ? $t('Valid') : $t('Invalid') }}
            </span>
        </template>
    </v-switch>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'SwitchSetting',
})
export default class SwitchSetting extends Vue {
    @Prop({ default: false }) value: boolean;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) loading: boolean;
    @Watch('value', { immediate: true })
    onValueChanged(val: boolean): void {
        this.flg = val;
    }
    @Watch('flg')
    onFlgChanged(val: boolean): void {
        this.$emit('input', val);
        this.$emit('change');
    }

    flg = false;

    get isEditable(): boolean {
        return this.editable;
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get isLoading(): boolean {
        return this.loading;
    }
}
</script>
